import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'Preciso de cartão de crédito para o teste grátis?',
    answer: 'Não! Você pode começar seu teste grátis sem precisar cadastrar nenhum cartão de crédito.',
  },
  {
    question: 'Posso cancelar a qualquer momento?',
    answer: 'Sim! Você pode cancelar sua assinatura a qualquer momento sem custos adicionais ou multas.',
  },
  {
    question: 'Quais integrações estão disponíveis?',
    answer: 'Oferecemos integração com mais de 10 gateways de pagamento, incluindo Hotmart, Stripe, Mercado Pago, Kiwify, Eduzz, PayPal, PagSeguro, Iugu, Vindi e Pagar.me.',
  },
  {
    question: 'Como funciona o suporte?',
    answer: 'Oferecemos suporte em português por email para todos os planos. Planos Enterprise incluem suporte prioritário com tempo de resposta garantido.',
  },
  {
    question: 'Posso importar dados históricos?',
    answer: 'Sim! Você pode importar seus dados históricos através de planilhas Excel ou CSV, ou conectar diretamente com seu gateway de pagamento.',
  },
  {
    question: 'É possível gerenciar múltiplos produtos?',
    answer: 'Sim! Todos os planos permitem gerenciar múltiplos produtos e serviços em uma única conta, facilitando a análise consolidada.',
  },
  {
    question: 'Os dados são seguros?',
    answer: 'Sim! Utilizamos criptografia de ponta a ponta e seguimos as melhores práticas de segurança. Seus dados são armazenados em servidores seguros e nunca são compartilhados.',
  },
  {
    question: 'Posso mudar de plano depois?',
    answer: 'Sim! Você pode fazer upgrade ou downgrade do seu plano a qualquer momento. As mudanças são refletidas imediatamente.',
  },
];

export function FAQSection() {
  return (
    <section id="faq" className="py-20 md:py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-muted-foreground">
            Tire suas dúvidas sobre o Dashi
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Coluna 1 */}
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.slice(0, 4).map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border rounded-lg px-6">
                  <AccordionTrigger className="text-left hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Coluna 2 */}
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.slice(4, 8).map((faq, index) => (
                <AccordionItem key={index} value={`item-${index + 4}`} className="border rounded-lg px-6">
                  <AccordionTrigger className="text-left hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
